import {createSlice, PayloadAction} from "@reduxjs/toolkit/react"
import {useSelector} from "react-redux"
import {StoreState} from "../store"

interface StateProps {
    theme: "light" | "dark"
    selectedBranchId?: string
}

const initialState: StateProps = {
    theme: "dark",
    selectedBranchId: undefined
}

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        changeTheme: (state, action: PayloadAction<StateProps["theme"]>) => {
            state.theme = action.payload
        },
        setSelectedBranchId: (state, action: PayloadAction<string | undefined>) => {
            state.selectedBranchId = action.payload
        }
    }
})

export const {changeTheme, setSelectedBranchId} = appSlice.actions

export default appSlice.reducer

export const useSelectedApp = () => {
    return useSelector((state: StoreState) => state.app)
}
